
export function comma(i, list, commaStr=", ") {
  if (!list) {
    return ""
  }
  if (i < (list.length - 1)) {
    return commaStr
  }
  return ""
}